module.exports = __webpack_public_path__ + "img/gzh.b5d8d9a8.png";